import {useEffect, useState} from "react";
import Validator from "../Validator";

function Select({title, initialError, options, id, value, setValue, required, updateObject, groups = false}) {
    const [error, setError] = useState(initialError);
    useEffect(() => {setError(initialError);}, [initialError]);

    function handleChange(event) {
        if (typeof setValue === 'function') {
            setValue(event.target.value);
        }

        validate(event.target.value);

        if (typeof updateObject === 'function') {
            updateObject(id, event.target.value);
        }
    }

    function validate(option) {
        setError(Validator.validateField(option, id, required, "select"));
    }

    return (
        <>
            <label htmlFor={id} className="sr-only">{title}{required ? "*" : ""}</label>
            <select id={id} name={id} onChange={handleChange} onBlur={handleChange} required={required} value={value}
                    className={"block py-2.5 px-0 w-full text-sm text-primary bg-transparent border-0 border-b-2 " +
                        (error ? "border-red-500 " : "border-gray-300 ") +
                        "focus:outline-none focus:ring-0 focus:border-gray-200 peer"}>
                <option disabled value="">{title}{required ? "*" : ""}</option>
                {groups ?
                    options.map((group, index) => (
                        <optgroup key={index} label={group.title}>
                            {group.options.map((option, index) => (
                                <option key={index} value={option.value}>{option.title}</option>
                            ))}
                        </optgroup>
                    ))
                    :
                    options.map((option, index) => (
                        <option key={index} value={option.value}>{option.title}</option>
                    ))
                }

            </select>
            {error ?
                (
                    <p className="mt-0 text-xs text-red-600 font-medium">{error}</p>
                )
                : ""}
        </>
    );
}

export default Select;